import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { BehaviorSubject, Observable } from 'rxjs'
import { ProductService } from './product.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Device } from 'src/app/modals/device';
import { ApiUtils } from './ApiUtils';
import { ApiEndpoints } from './ApiEndpoints';
import { plainToClass } from 'class-transformer';
@Injectable({
    providedIn: 'root'
})

export class MessagingService {

    currentMessage = new BehaviorSubject(null);

    // tslint:disable-next-line:max-line-length
    constructor(private httpClient: HttpClient, private router: Router, private angularFireMessaging: AngularFireMessaging, private productService: ProductService, private deviceService: DeviceDetectorService, public apiUtils: ApiUtils, public apiEndpoints: ApiEndpoints,) {
        this.angularFireMessaging.messaging.subscribe((_messaging) => {
        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
        })
    }

    getDevice(): Device {

        const device = JSON.parse(localStorage.getItem('device')) || undefined;

        if( device !== undefined)
        return plainToClass(Device, device as object);
        else
        return undefined;

    }

    requestPermission() {

        this.angularFireMessaging.requestToken.subscribe((token) => {

            console.log('Firebase token: ',token);

            let device = this.getDevice();

            /* if( device === undefined ) {

                const newdevice = new Device();
                this.saveDevice(newdevice, token).then( dataDevice => {
                    localStorage.setItem('device', JSON.stringify(dataDevice));
                });

            } else {

                if(device.firebase_token !== token) {

                    this.saveDevice(device, token).then( dataDevice => {
                        localStorage.setItem('device', JSON.stringify(dataDevice));
                    });

                }

            } */

            if( device === undefined ) {

                device = new Device();

            }

            this.saveDevice(device, token).then( dataDevice => {
                localStorage.setItem('device', JSON.stringify(dataDevice));
            });


        },(err) => {
            console.error('Unable to get permission to notify.', err);
        });

    }

    private geolocation(): Observable<any> {
        // return this.httpClient.get<Product[]>('assets/data/products2.json');
        return this.httpClient.get<any>('https://geolocation-db.com/json/');
        // return [];
    }

    receiveMessage() {

        this.angularFireMessaging.messages.subscribe((payload:any) => {

            console.log('new message received. ', payload);

            if( payload.notification !== undefined) {

                // tslint:disable-next-line:max-line-length
                this.productService.snackBar.open(payload.notification.body, '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });

            }

            if( payload.data !== undefined &&  payload.data.link !== undefined &&  payload.data.type !== undefined &&  payload.data.type === 'openlink') {

                this.router.navigate([payload.data.link]);

            }

            this.currentMessage.next(payload);

        })

    }

    saveDevice(device: Device, token: string){

        return new Promise<Device>( resolve => {

            console.log(this.deviceService.getDeviceInfo());

            const deviceInfo = this.deviceService.getDeviceInfo();

            device.os = deviceInfo.os;
            device.os_version = deviceInfo.os_version;
            device.browser = deviceInfo.browser;
            device.browser_version = deviceInfo.browser_version;

            if(this.deviceService.isMobile())
            device.type = 'mobile';

            if(this.deviceService.isTablet())
            device.type = 'Tablet';

            if(this.deviceService.isDesktop())
            device.type = 'desktop';


            // recuperation infos position
            this.geolocation().subscribe( location => {

                console.log(location);
                device.firebase_token = token;
                device.ipv4 = location.IPv4;
                device.latitude = location.latitude;
                device.longitude = location.longitude;
                device.city = location.city;
                device.country_name = location.country_name;
                device.country_code = location.country_code;

                this.save(device).subscribe( (data: Device) => {
                    resolve(data);
                }, err => {
                    console.log(err);
                    // on supprime l'appareil en local au cas ou le l'appareil avait déjà été enregistré
                    localStorage.removeItem('device');
                });


            }, err => {

                console.log(err);

                this.save(device).subscribe( (data: Device) => {
                    resolve(data);
                }, errSave => {
                    console.log(errSave);
                    // on supprime l'appareil en local au cas ou le l'appareil avait déjà été enregistré
                    localStorage.removeItem('device');
                });
            });


        });

      }

      save(device: Device) {

        const dev = {
            // dateCreate: device.date_create,
            firebaseToken: device.firebase_token,
            // dateLastVisit: device.date_last_visit,
            browser: device.browser,
            browserVersion: device.browser_version,
            os: device.os,
            osVersion: device.os_version,
            type: device.type,
            lang: device.lang,
            countryCode: device.country_code,
            countryName: device.country_name,
            latitude: device.latitude,
            longitude: device.longitude,
            city: device.city,
            ipv4: device.ipv4,
            // user: null
        };
        /* console.log(fac);
        return */
        if(device.id === 0 ||device.id === undefined)
        return this.httpClient.post(this.apiEndpoints.GET_URL_POST_DEVICE(), dev, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        else
        // tslint:disable-next-line:max-line-length
        return this.httpClient.patch(this.apiEndpoints.GET_URL_PATCH_DEVICE(device.id), dev, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})

     }

}